const $inject = ['$location', 'authService', 'settingsService'];

const authCallbackService = function ($location, authService, settingsService) {
  let service = {};
  service.checkCallBack = checkCallBack;
  service.shouldRedirectToReact = false;
  function checkCallBack() {
    const path = $location.$$path;
    if (path && path.includes('access_token=')) {
      const contents = path.substring(path.indexOf('access_token='));
      const parmStr = contents.split('&');
      let parms = [];
      parmStr.forEach((str) => {
        const item = str.split('=');
        if (item.length == 2) {
          parms[item[0]] = item[1];
        }
      });
      if (parms['access_token'] && parms['expires_in']) {
        authService.storeAuth({
          expires_in: parms['expires_in'],
          access_token: parms['access_token'],
        });
        settingsService.get(true).then(() => {
          if(window.ENABLE_REACT_LOGIN && !!settingsService.settings && !!settingsService.settings.RedirectToReactHomePage){
            service.shouldRedirectToReact = true;
          }
          const previousState = localStorage.getItem('previousState');
          if (previousState && !previousState.includes('login')) {
            const previousStatetoParams = localStorage.getItem('previousStatetoParams');
            let toParams = {};
            if (previousStatetoParams) {
              toParams = JSON.parse(previousStatetoParams);
            }
            $location.$$search = toParams;
            $location.path(previousState);
          }
        });
      }
    }
  }

  return service;
};

authCallbackService.$inject = $inject;

export default authCallbackService;



// WEBPACK FOOTER //
// ./src/services/authCallbackService.js